<template>
    <g>
        <path
            d="M9.1665 3.83337H3.33317C2.89114 3.83337 2.46722 4.00897 2.15466 4.32153C1.8421 4.63409 1.6665 5.05801 1.6665 5.50004V17.1667C1.6665 17.6087 1.8421 18.0327 2.15466 18.3452C2.46722 18.6578 2.89114 18.8334 3.33317 18.8334H14.9998C15.4419 18.8334 15.8658 18.6578 16.1783 18.3452C16.4909 18.0327 16.6665 17.6087 16.6665 17.1667V11.3334"
            :stroke="iconFill"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M15.4165 2.58332C15.748 2.2518 16.1977 2.06555 16.6665 2.06555C17.1353 2.06555 17.585 2.2518 17.9165 2.58332C18.248 2.91484 18.4343 3.36448 18.4343 3.83332C18.4343 4.30216 18.248 4.7518 17.9165 5.08332L9.99984 13L6.6665 13.8333L7.49984 10.5L15.4165 2.58332Z"
            :stroke="iconFill"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </g>
</template>
<script>
export default {
    name: "EditPencil2021",
    props: {
        iconFill: {
            type: String,
            default: "#206CFF",
        },
    },
};
</script>
